"use client";

import PageSection from "@/app/(core)/components/PageSection";
import SectionHeader from "@/app/(core)/components/SectionHeader";
import WaveBanner from "@/app/components/footer/components/WaveBanner";
import { Box, darken, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import classes from "./team-content.module.css";
import ApplyFormWrapper from "./components/ApplyFormWrapper";
import TeamModule from "./components/TeamModule";

interface TeamContentProps {
  subjectNames: string[];
}

export default function TeamContent({ subjectNames }: TeamContentProps) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");

  return (
    <main>
      {/* 1. Team grid - now first section */}
      <PageSection variant="dark" firstSection>
        <SectionHeader
          title="Meet The Team."
          subTitle="World-class teachers, each with immense experience. Our team has spent decades specialising in the IB."
          align="center"
          needsLightTitle={true}
          isFirstSection
        />
        <Box className={classes.teamGridWrap}>
          <TeamModule />
        </Box>
      </PageSection>
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 2. Join CTA + form */}
      <PageSection variant="light" minHeight={false}>
        <SectionHeader
          title="Want To Join The Tiber Team?"
          subTitle="We are always looking to expand our team to deliver the leading resources for the IB."
          align="center"
        />
        <Box className={classes.formWrap}>
          <ApplyFormWrapper subjectNames={subjectNames} />
        </Box>
      </PageSection>
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? theme.colors.dark[9]
            : darken(theme.colors.darkblue[9], 0.2)
        }
      />
    </main>
  );
}
